export default __webpack_public_path__ + "static/media/style_img.e32b4418.jpg";